import {Component, OnInit, OnDestroy, Input} from "@angular/core";
import {Router, NavigationEnd} from "@angular/router";
import {trigger, transition, style, animate, state} from "@angular/animations";
import {BackgroundService} from "../background.service";
import {Subscription} from "rxjs";
import {filter} from "rxjs/operators";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.css"],
  animations: [
    trigger("backgroundChange", [
      state("show", style({opacity: 1})),
      state("hide", style({opacity: 0})),
      transition("show <=> hide", [animate("1s ease-in-out")]),
    ]),
    trigger("routeAnimations", [
      transition("* <=> *", [
        style({opacity: 0}),
        animate("350ms", style({opacity: 1})),
      ]),
    ]),
  ],
})
export class MainComponent implements OnInit, OnDestroy {
  @Input() customCardClass: string;
  backgroundImage: string;
  newBackgroundImage: string;
  interval: any;
  showNewImage = false;
  isUnregisterPage = false;
  routerSubscription: Subscription;

  constructor(public backgroundService: BackgroundService, private router: Router) {
    this.backgroundImage = this.backgroundService.getRandomBackground();
    this.newBackgroundImage = this.backgroundImage;
  }

  ngOnInit(): void {
    this.interval = setInterval(() => {
      const newImage = this.backgroundService.getNewRandomBackground();
      const img = new Image();
      img.src = newImage;
      img.onload = () => {
        this.newBackgroundImage = newImage;
        this.showNewImage = true;
        setTimeout(() => {
          this.backgroundImage = this.newBackgroundImage;
          this.showNewImage = false;
        }, 1000);
      };
    }, 30000);

    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isUnregisterPage = event.urlAfterRedirects.includes("unregister");
      this.customCardClass = this.isUnregisterPage ? "custom-card-unregister" : "custom-card-other";
    });
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  navigateToLanding(): void {
    this.router.navigate(["/landing"]);
  }
}


